import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function TypeApp() {
  return (
    <section className="typeapp_smack p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} className="my-auto">
            <h2>How Much Do These Type Of Apps Really Earn?</h2>
            <p>
              smackback was created to help users streamline and automate the
              important task of scheduling messages. The app is currently free
              from any monetization and neither has any locked features that you
              need to access via in-app purchases and neither does it show any
              sort of ads. Other apps in the genre do have monetization models
              which primarily revolve around in-app purchases, but this can make
              the user feel unnecessarily burdened towards accommodating
              additional costs for using the most important features of the app.
              It’s very rare for apps to make a lot of money in this genre, and
              if you are looking towards getting an app developed with a
              powerful revenue generation model, we suggest you go for
              categories that support models like gaming apps or on-demand
              delivery apps. To know more, find out how much your app can earn
              in 2020.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} className="my-auto offset-lg-1">
            <StaticImage
              src="../../../images/case-studies/smackback/blue-bg.webp"
              alt="Smackback TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={936}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TypeApp;
